import VueHotjar from 'vue-hotjar-next';
import envConfig from '../../env.config.json';

// Get the environment based on process.env.NODE_ENV or default to 'development'
const env = process.env.NODE_ENV || 'development';
const config = envConfig[env] || envConfig['development'];

export default {
  install(app, options) {
    if (typeof window === 'undefined') return;
    
    const hotjarId = parseInt(config.HOTJAR_ID);
    if (!hotjarId) {
      return;
    }

    // Initialize VueHotjar with your configuration
    app.use(VueHotjar, {
      id: hotjarId,
      isProduction: true, // Enable for all environments
      snippetVersion: 6
    });

    // Add custom methods to the app instance
    app.config.globalProperties.$hotjar = {
      isLoaded: false,
      
      // Method to manually trigger specific Hotjar events
      trigger(eventName) {
        if (window.hj) {
          window.hj('trigger', eventName);
        }
      },
      
      // Method to identify users
      identify(userId, userAttributes) {
        if (window.hj) {
          window.hj('identify', userId, userAttributes);
        }
      },
      
      // Method to set user attributes
      setUserAttribute(name, value) {
        if (window.hj) {
          const attributes = {};
          attributes[name] = value;
          window.hj('identify', null, attributes);
        }
      },

      // Method to start recording
      startRecording() {
        if (window.hj) {
          window.hj('recording', 'start');
        }
      },

      // Method to stop recording
      stopRecording() {
        if (window.hj) {
          window.hj('recording', 'stop');
        }
      }
    };

    // Watch for Hotjar initialization
    const checkHotjarLoaded = setInterval(() => {
      if (window.hj) {
        app.config.globalProperties.$hotjar.isLoaded = true;
        clearInterval(checkHotjarLoaded);
      }
    }, 100);

    // Clear interval after 10 seconds to prevent infinite checking
    setTimeout(() => {
      clearInterval(checkHotjarLoaded);
      if (!app.config.globalProperties.$hotjar.isLoaded) {
      }
    }, 10000);
  }
}; 